import React, { useEffect, useState } from "react";
import { View } from "react-native";
import NewsletterSection from "./news-letter-section";
import DesktopFooter from "./desktop-footer";
import MobileFooter from "./mobile-footer";
import SocialLinks from "./social-links";
import apiHelpers from "../../utils/api-helpers";

const FooterMain = ({
  token,
  userProfile,
  chargebee_billing_platform,
  locationInfo,
}) => {
  const [footerData, setFooterData] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchFooterData = async () => {
      try {
        const response = await apiHelpers.apiRequest(
          "/footer",
          {},
          "GET",
          true,
        );
        console.log("response", response);

        if (!isMounted || !response.success) {
          return;
        }

        setFooterData(response.data);
      } catch (error) {
        console.log("Error=>> footer main", JSON.stringify(error));
      }
    };

    fetchFooterData();

    return () => {
      isMounted = false;
    };
  }, []);

  if (!footerData) {
    return null;
  }

  return (
    <View>
      <NewsletterSection token={token} userProfile={userProfile} />
      <DesktopFooter
        footerData={footerData}
        token={token}
        userProfile={userProfile}
        chargebee_billing_platform={chargebee_billing_platform}
        locationInfo={locationInfo}
      />
      <MobileFooter footerData={footerData} />
      <SocialLinks footerData={footerData} />
    </View>
  );
};

export default FooterMain;
